import Pagination from "@/components/pagination";
import KnowledgeAddModal from "@/components/writingComponent/knowledgeAddModal";
import KnowledgeEditModal from "@/components/writingComponent/knowledgeEditModal";
import { Knowledge } from "@/types/writing";
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { SlMagnifier } from "react-icons/sl";
import { useNavigate } from "react-router-dom";

const KnowledgeBaseSet = () => {
  const addControl = useDisclosure();
  const editControl = useDisclosure();
  const delControl = useDisclosure();
  const navigate = useNavigate();
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [searchValue, setSearchValue] = useState("");
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentEditForm, setCurrentEditForm] = useState<Knowledge>();

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };
  const onPageSizeChange = (page: number) => {
    setPageSize(page);
  };

  const handleAdd = () => {
    addControl.onOpen();
  };

  const knowledgeDatas: Knowledge[] = [
    {
      id: "1",
      user_id: "",
      title: "11",
      isPublic: "私有",
      intro: "123456",
      docOverlapNum: 0,
      docRecallMaxNum: 0,
      docRecallMinNum: 0.0,
      resRandomness: 0.0,
    },
  ];

  const handleClickEdit = (row: Knowledge) => {
    setCurrentEditForm(row);
    editControl.onOpen();
  };

  const handleClickDel = (row: Knowledge) => {
    setCurrentEditForm(row);
    delControl.onOpen();
  }

  const handleDelete = () => {
    console.log(currentEditForm);
    delControl.onClose();
  }

  return (
    <>
      <Box m="0 20px">
        <HStack spacing={0} mt="20px" mb="10px">
          <Button
            color="#27314D"
            fontWeight={"normal"}
            fontSize={"14px"}
            variant="link"
            onClick={() => {
              navigate("/ai/writing");
            }}
          >
            首页
          </Button>
          <Text color="#27314D" fontSize={"14px"}>
            {" "}
            &gt; 我的知识库
          </Text>
        </HStack>
        <Flex justifyContent={"space-between"}>
          <Button
            w="56px"
            h="30px"
            bg="#496AE1"
            color={"#FFFFFF"}
            fontSize="14px"
            fontWeight={"normal"}
            borderRadius={0}
            _hover={{
              bg: "#3F5BC1",
              color: "#E6E6E6",
            }}
            onClick={handleAdd}
          >
            添加
          </Button>
          <InputGroup w="280px">
            <Input
              h="34px"
              // w="400px"
              boxSizing="border-box"
              border="1px solid #8E94A9"
              borderRadius={0}
              bg="none"
              color={"#8E94A9"}
              fontSize="12px"
              placeholder="请输入"
              size="md"
              value={searchValue}
              onChange={handleChangeSearchValue}
            />
            <InputRightElement>
              <SlMagnifier color="#8E94A9" />
            </InputRightElement>
          </InputGroup>
        </Flex>
        <Box mt="10px">
          <TableContainer>
            <Table variant="simple" fontSize="14px" fontWeight={"normal"}>
              <Thead color={"#333333"} bgColor="#fafafc">
                <Tr>
                  <Th fontSize="14px" fontWeight={"normal"}>
                    标题
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"}>
                    描述
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"}>
                    是否公开
                  </Th>
                  <Th
                    fontSize="14px"
                    fontWeight={"normal"}
                    textAlign="center"
                    w="120px"
                  >
                    操作
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {knowledgeDatas.map((row, index) => {
                  return (
                    <Tr key={index} color="#333333">
                      <Td>{row.title}</Td>
                      <Td>{row.intro}</Td>
                      <Td>{row.isPublic}</Td>
                      <Td textAlign="center">
                        <Button
                          color={"#496AE1"}
                          fontSize="14px"
                          fontWeight={"normal"}
                          variant="link"
                          onClick={() => handleClickEdit(row)}
                        >
                          编辑
                        </Button>
                        <Button
                          color={"#496AE1"}
                          fontSize="14px"
                          fontWeight={"normal"}
                          variant="link"
                          onClick={() => handleClickDel(row)}
                        >
                          删除
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
          <Pagination
            total={total}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </Box>
      </Box>

      {/* 添加*/}
      <KnowledgeAddModal
        isOpen={addControl.isOpen}
        onClose={addControl.onClose}
      />

      {/* 编辑*/}
      <KnowledgeEditModal
        isOpen={editControl.isOpen}
        onClose={editControl.onClose}
        editForm={currentEditForm!}
      />
      {/* 删除 */}
      <AlertDialog
        isOpen={delControl.isOpen}
        leastDestructiveRef={cancelRef}
        onClose={delControl.onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              删除
            </AlertDialogHeader>

            <AlertDialogBody>
              你确定要删除吗
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={delControl.onClose}>
                取消
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                确定
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default KnowledgeBaseSet;
